import * as Types from './actionTypes';

export function routingActionCreator(route) {
    return {
        type: route
    };
}
